import styled from 'styled-components';
import { ColorMixin } from '../../../styles/global';

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  gap: 10px;
  margin-top: 20px;

  button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    letter-spacing: 4px;
    color: ${ColorMixin?.secondary};
    transition: 700ms all;
    outline: none;
    font-size: 14px;

    &:hover {
      color: orange;
    }

    .active {
      color: ${ColorMixin?.active};
    }
  }

  @media screen and (min-width: 400px) {

    button {
      font-size: 18px;
    }
  }
  @media screen and (min-width: 600px) {
    gap: 40px;
    margin: 40px 0;

    button {
      font-size: 20px;
    }
  }
`;
